import React from "react";
import PATH from "constants/path";
import { isAuthenticated } from "utils/common";
import { SERVICE } from "constants/global";
import { Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  if (!isAuthenticated()) {
    window.location = `${
      PATH.COMMON
    }?service=${SERVICE}&redirect_uri=${encodeURIComponent(
      window.location.href
    )}`;
    return null;
  }

  return <Route {...rest} component={Component} />;
};

export default PrivateRoute;
